\<template>
  <div
    class="form-group"
    :class="{
      'input-group-focus': focused,
      'has-label': label,
      'has-icon': hasIcon,
      'has-danger': hasErrorStatus,
    }"
  >
    <slot name="label">
      <label v-if="label"> {{ label }} {{ required ? '*' : '' }} </label>
    </slot>
    <div class="mb-0" :class="{'input-group': hasIcon}">
      <slot name="addonLeft">
        <span v-if="addonLeftIcon" class="input-group-prepend">
          <div class="input-group-text"><i :class="addonLeftIcon"></i></div>
        </span>
      </slot>
      <slot>
        <input
          :value="value"
          v-bind="$attrs"
          v-on="listeners"
          @keydown="handleKeyDown"
          ref="inputRef"
          class="form-control"
          aria-describedby="addon-right addon-left"
        />
      </slot>
      <slot name="addonRight">
        <span v-if="addonRightIcon" class="input-group-append">
          <div class="input-group-text"><i :class="addonRightIcon"></i></div>
        </span>
      </slot>
    </div>

    <slot name="error" v-if="displayError || $slots.error">
      <label class="error">{{ displayError }}</label>
   </slot>
    <slot name="helperText"></slot>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: 'base-input',
  props: {
    disableAutoPasswordValidation : {
       type: Boolean,
       default: false
    },
    isPasswordField: {
       type: Boolean,
       default: false
    },
    errorstatus: Boolean,
    required: Boolean,
    label: {
      type: String,
      description: 'Input label'
    },
    error: {
      type: String,
      description: 'Input error',
      default: ''
    },
    value: {
      type: [String, Number],
      description: 'Input value'
    },
    addonRightIcon: {
      type: String,
      description: 'Input icon on the right'
    },
    addonLeftIcon: {
      type: String,
      description: 'Input icon on the left'
    },
    lowercase: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data() {
    return {
      focused: false,
      touched: false,
      initerrorstatus: false,
    };
  },
  computed: {
    autoPasswordError() {
     if (this.disableAutoPasswordValidation) return "";
      const isPassword = this.isPasswordField || this.$attrs.type === 'password' || this.type === 'password';
      if (isPassword) {
        if (this.value && this.value.length < 8) {
          return "Password must be long 8 character";
        }
      }
      return "";
    }, 
    displayError() {
      return this.error || this.autoPasswordError;
    },
    hasErrorStatus() {
      return this.errorstatus || this.autoPasswordError !== "";
    },
    hasIcon() {
      return this.hasLeftAddon || this.hasRightAddon
    },
    hasLeftAddon() {
      const { addonLeft } = this.$slots;
      return (
        addonLeft !== undefined ||
        this.addonLeftIcon !== undefined
      );
    },
    hasRightAddon() {
      const { addonRight } = this.$slots;
      return (
        addonRight !== undefined ||
        this.addonRightIcon !== undefined
      );
    },
    listeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
        blur: this.onBlur,
        focus: this.onFocus
      };
    }
  },
  methods: {
    onInput(evt) {
      if (!this.touched) {
        this.touched = true;
      }
      
      const inputElement = this.$refs.inputRef;
      const cursorPosition = inputElement.selectionStart;

      let newValue;
      if (this.lowercase) {
        newValue = evt.target.value.toLowerCase();
      } else {
        newValue = evt.target.value;
      }

      this.$emit('input', newValue);

      if (this.lowercase) {
        // Restore the cursor position
        this.$nextTick(() => {
          inputElement.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
      // const newValue = this.lowercase ? evt.target.value.toLowerCase() : evt.target.value;
      // this.$emit('input',newValue);
    },
    onFocus(evt) {
      if (this.lowercase) {
        evt.target.type = "text"
      }
      this.focused = true;
      this.$emit('focus', evt)
    },
    onBlur(evt) {
      if (this.lowercase) {
        evt.target.type = "email"
      }
      this.focused = false;
      this.$emit('blur', evt)
    },
    handleKeyDown(evt) {
      if (this.lowercase) {
        if (evt.key == 'Enter' && this.lowercase) {
          evt.target.type = "email"
        }else {
          evt.target.type = "text";
        }
      }
    },
  }
};
</script>
<style></style>
